// @ts-nocheck

(function () {
  if (window.GoldNovoContactFormInitialized) {
    return;
  }

  window.GoldNovoContactFormInitialized = true;

  function canUseSessionStorage() {
    try {
      const key = '__goldnovo_contact_form__';
      window.sessionStorage.setItem(key, '1');
      window.sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  }

  const hasSessionStorage = canUseSessionStorage();
  const DEFAULT_SUCCESS_PATH = '/pages/thank-you-contact';
  const DEFAULT_LOADING_LABEL = 'Submitting...';
  const DEFAULT_STATUS_MESSAGE = 'Submitting your inquiry. Please wait a moment...';
  const DEFAULT_SUCCESS_MESSAGE = 'Thanks! Your inquiry has been received. Redirecting you now...';
  const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';
  const RATE_LIMIT_ERROR_MESSAGE = 'Too many attempts detected. Please wait a few minutes and try again.';
  const NETWORK_ERROR_MESSAGE = 'Network error. Please check your connection and try again.';
  const SERVER_ERROR_MESSAGE = 'Server error. Please try again in a little while.';
  const SUCCESS_REDIRECT_DELAY = 600;

  function getForms(root) {
    const forms = [];
    if (root instanceof HTMLFormElement && root.matches('[data-contact-form]')) {
      forms.push(root);
    }
    if (root instanceof Element || root instanceof Document) {
      forms.push(...root.querySelectorAll('[data-contact-form]'));
    }
    return forms;
  }

  function getPersistedFields(form) {
    return Array.from(form.querySelectorAll('[data-contact-persist]'));
  }

  function isTextLikeField(field) {
    if (field instanceof HTMLTextAreaElement) return true;
    if (!(field instanceof HTMLInputElement)) return false;

    return ['text', 'email', 'tel', 'url', 'search', 'password'].indexOf(field.type) !== -1;
  }

  function syncFieldValidity(field) {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;

    if (isTextLikeField(field)) {
      if (field.required && field.value.trim() === '') {
        field.setCustomValidity('This field is required');
        return;
      }

      field.setCustomValidity('');
      return;
    }

    field.setCustomValidity('');
  }

  function prepareFieldForValidation(field) {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;
    syncFieldValidity(field);
  }

  function getStorageKey(form) {
    return form.dataset.contactFormStorageKey || '';
  }

  function normalizePath(path) {
    if (!path) return '';
    return path.replace(/^[a-z]+:\/\/[^/]+/i, '').replace(/[?#].*$/, '') || '/';
  }

  function getSuccessPath(form) {
    return normalizePath(form.dataset.contactSuccessPath || DEFAULT_SUCCESS_PATH);
  }

 function getSuccessUrl(form) {
  var baseUrl = form.dataset.contactSuccessUrl || getSuccessPath(form);
  var currentParams = window.location.search; // 获取当前页面所有参数（含 gclid）
  if (currentParams) {
    return baseUrl + currentParams;
  }
  return baseUrl;
}

  function getFormAction(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var url = new URL(action, window.location.origin);
    var shopUrl = form.dataset.contactShopUrl;

    if (shopUrl) {
      try {
        var shopBaseUrl = new URL(shopUrl, window.location.origin);
        url.protocol = shopBaseUrl.protocol;
        url.host = shopBaseUrl.host;
      } catch (error) {
        /* no-op */
      }
    }

    url.hash = '';
    return url.toString();
  }

  function getStatusNode(form) {
    return form.querySelector('[data-contact-status]');
  }

  function setStatusMessage(form, message, state) {
    var statusNode = getStatusNode(form);
    if (!(statusNode instanceof HTMLElement)) return;

    if (!message) {
      statusNode.hidden = true;
      statusNode.textContent = '';
      statusNode.removeAttribute('data-state');
      return;
    }

    statusNode.hidden = false;
    statusNode.textContent = message;
    if (state) {
      statusNode.dataset.state = state;
    } else {
      statusNode.removeAttribute('data-state');
    }
  }

  function getSubmitButton(form) {
    return form.querySelector('[type="submit"]');
  }

  function readButtonLabel(button) {
    if (!(button instanceof HTMLButtonElement || button instanceof HTMLInputElement)) return '';
    return button instanceof HTMLButtonElement ? button.textContent || '' : button.value || '';
  }

  function writeButtonLabel(button, label) {
    if (!(button instanceof HTMLButtonElement || button instanceof HTMLInputElement)) return;
    if (button instanceof HTMLButtonElement) {
      button.textContent = label;
      return;
    }
    button.value = label;
  }

  function setSubmittingState(form, isSubmitting) {
    var submitButton = getSubmitButton(form);
    form.dataset.contactSubmitting = isSubmitting ? 'true' : 'false';

    if (!(submitButton instanceof HTMLButtonElement || submitButton instanceof HTMLInputElement)) return;

    if (!submitButton.dataset.originalLabel) {
      submitButton.dataset.originalLabel = readButtonLabel(submitButton).trim();
    }

    if (isSubmitting) {
      form.classList.add('contact-form__form--submitting');
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      writeButtonLabel(submitButton, DEFAULT_LOADING_LABEL);
      return;
    }

    form.classList.remove('contact-form__form--submitting');
    submitButton.disabled = false;
    submitButton.removeAttribute('aria-disabled');
    writeButtonLabel(submitButton, submitButton.dataset.originalLabel || DEFAULT_LOADING_LABEL);
  }

  function ensureReturnToInput(form) {
    var successPath = getSuccessPath(form);
    if (!successPath) return;

    var returnToInput = form.querySelector('input[name="return_to"]');
    if (returnToInput instanceof HTMLInputElement) {
      returnToInput.value = successPath;
      return;
    }

    returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    returnToInput.value = successPath;
    form.appendChild(returnToInput);
  }

  function getResponsePath(url) {
    try {
      return normalizePath(new URL(url, window.location.origin).pathname);
    } catch (error) {
      return '';
    }
  }

  function parseHTML(html) {
    try {
      return new DOMParser().parseFromString(html, 'text/html');
    } catch (error) {
      return null;
    }
  }

  function getServerErrorMessage(doc) {
    if (!(doc instanceof Document)) return '';

    var errorMessage = doc.querySelector('.contact-form__error .contact-form__message-copy');
    if (errorMessage && errorMessage.textContent) {
      return errorMessage.textContent.trim();
    }

    return '';
  }

  function getRetryAfterSeconds(response) {
    if (!(response instanceof Response)) return 0;

    var retryAfter = response.headers.get('Retry-After');
    if (!retryAfter) return 0;

    var seconds = parseInt(retryAfter, 10);
    if (!Number.isNaN(seconds) && seconds > 0) {
      return seconds;
    }

    var retryDate = Date.parse(retryAfter);
    if (Number.isNaN(retryDate)) return 0;

    var diffSeconds = Math.round((retryDate - Date.now()) / 1000);
    return diffSeconds > 0 ? diffSeconds : 0;
  }

  function getHttpErrorMessage(response, doc, html) {
    var status = response && typeof response.status === 'number' ? response.status : 0;
    var serverMessage = getServerErrorMessage(doc);

    if (status === 429) {
      var retryAfterSeconds = getRetryAfterSeconds(response);
      if (retryAfterSeconds > 0) {
        return 'Too many attempts detected. Please wait ' + retryAfterSeconds + ' seconds and try again.';
      }
      return RATE_LIMIT_ERROR_MESSAGE;
    }

    if (status === 401 || status === 403) {
      if (isChallengeResponse(response, html)) {
        return 'A security check is required before sending this form.';
      }
      return 'This request was blocked. Please refresh the page and try again.';
    }

    if (status >= 500) {
      return SERVER_ERROR_MESSAGE;
    }

    return serverMessage || DEFAULT_ERROR_MESSAGE;
  }

  function getRequestErrorMessage(error) {
    if (error && error.name === 'AbortError') {
      return 'The request took too long and was stopped. Please try again.';
    }

    if (error instanceof TypeError) {
      return NETWORK_ERROR_MESSAGE;
    }

    return DEFAULT_ERROR_MESSAGE;
  }

  function isChallengeResponse(response, html) {
    var responsePath = getResponsePath(response.url);
    if (responsePath.indexOf('/challenge') === 0) return true;
    return /Shopify\.challenge|recaptcha|captcha/i.test(html);
  }

  function shouldFallbackToNativeSubmission(response, html) {
    if (!(response instanceof Response)) return false;

    if (isChallengeResponse(response, html)) {
      return true;
    }

    if (response.status === 401 || response.status === 403) {
      return true;
    }

    return false;
  }

  function isSuccessResponse(response, doc, successPath) {
    var responsePath = getResponsePath(response.url);
    if (successPath && responsePath === successPath) return true;
    return doc instanceof Document && Boolean(doc.querySelector('.contact-form__success'));
  }

  async function submitFormWithAjax(form) {
    ensureReturnToInput(form);

    var formData = new FormData(form);
    formData.set('return_to', getSuccessPath(form));

    var response = await fetch(getFormAction(form), {
      method: (form.getAttribute('method') || 'post').toUpperCase(),
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
      credentials: 'same-origin',
      redirect: 'follow'
    });

    var html = await response.text();
    return {
      response: response,
      html: html,
      doc: parseHTML(html)
    };
  }

  function fallbackToNativeSubmit(form) {
    var submitButton = getSubmitButton(form);

    form.dataset.contactNativeSubmit = 'true';
    setSubmittingState(form, false);

    if (submitButton instanceof HTMLButtonElement || submitButton instanceof HTMLInputElement) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-disabled');
    }

    if (typeof form.requestSubmit === 'function') {
      if (submitButton instanceof HTMLButtonElement || submitButton instanceof HTMLInputElement) {
        form.requestSubmit(submitButton);
      } else {
        form.requestSubmit();
      }
      return;
    }

    if (submitButton instanceof HTMLElement) {
      submitButton.click();
      return;
    }

    form.submit();
  }

  function redirectToSuccessPage(form) {
    window.setTimeout(function () {
      window.location.assign(getSuccessUrl(form));
    }, SUCCESS_REDIRECT_DELAY);
  }

  function readState(form) {
    if (!hasSessionStorage) return {};
    const storageKey = getStorageKey(form);
    if (!storageKey) return {};
    try {
      const state = window.sessionStorage.getItem(storageKey);
      return state ? JSON.parse(state) : {};
    } catch (error) {
      return {};
    }
  }

  function writeState(form) {
    if (!hasSessionStorage) return;
    const storageKey = getStorageKey(form);
    if (!storageKey) return;

    const nextState = {};
    getPersistedFields(form).forEach((field) => {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;
      if (!field.name) return;
      if (field.type === 'radio') {
        if (field.checked) nextState[field.name] = field.value;
        return;
      }
      nextState[field.name] = field.value;
    });

    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(nextState));
    } catch (error) {
      /* no-op */
    }
  }

  function clearState(form) {
    if (!hasSessionStorage) return;
    const storageKey = getStorageKey(form);
    if (!storageKey) return;
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      /* no-op */
    }
  }

  function restoreState(form) {
    const state = readState(form);
    getPersistedFields(form).forEach((field) => {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;
      if (!field.name || !(field.name in state)) return;
      const savedValue = state[field.name];
      if (field.type === 'radio') {
        if (!field.checked && savedValue === field.value) field.checked = true;
        return;
      }
      if (field.value === '') field.value = savedValue;
    });
  }

  function updateMaterialOtherField(form) {
    var materialSelect = form.querySelector('[data-material-select]');
    var otherFieldWrapper = form.querySelector('[data-material-other-wrapper]');
    var otherFieldInput = form.querySelector('[data-material-other-input]');

    if (
      !(materialSelect instanceof HTMLSelectElement) ||
      !(otherFieldWrapper instanceof HTMLElement) ||
      !(otherFieldInput instanceof HTMLInputElement)
    ) return;

    var shouldShow = materialSelect.value === 'Other Materials';
    otherFieldWrapper.hidden = !shouldShow;
    otherFieldInput.disabled = !shouldShow;
    otherFieldInput.required = shouldShow;
    otherFieldInput.setAttribute('aria-required', shouldShow ? 'true' : 'false');
  }

  function updateBusinessTypeOtherField(form) {
    var businessTypeSelect = form.querySelector('[data-business-type-select]');
    var otherFieldWrapper = form.querySelector('[data-business-type-other-wrapper]');
    var otherFieldInput = form.querySelector('[data-business-type-other-input]');

    if (
      !(businessTypeSelect instanceof HTMLSelectElement) ||
      !(otherFieldWrapper instanceof HTMLElement) ||
      !(otherFieldInput instanceof HTMLInputElement)
    ) return;

    var shouldShow = businessTypeSelect.value === 'Others';
    otherFieldWrapper.hidden = !shouldShow;
    otherFieldInput.disabled = !shouldShow;
    otherFieldInput.required = shouldShow;
    otherFieldInput.setAttribute('aria-required', shouldShow ? 'true' : 'false');
  }

  function getErrorMessage(field) {
    prepareFieldForValidation(field);
    var validity = field.validity;
    if (validity.valueMissing) return 'This field is required';
    if (validity.typeMismatch) {
      if (field.type === 'email') return 'Please enter a valid email address';
      if (field.type === 'url') return 'Please enter a valid URL (e.g. https://example.com)';
    }
    if (validity.tooShort) return 'Please enter at least ' + field.getAttribute('minlength') + ' characters';
    if (validity.tooLong) return 'Please enter no more than ' + field.getAttribute('maxlength') + ' characters';
    if (validity.patternMismatch) return 'Please match the requested format';
    return 'Please fill out this field correctly';
  }

  function showFieldError(field, message) {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;

    field.classList.add('contact-form__input--error');

    var fieldWrapper = field.closest('.contact-form__field');
    if (!fieldWrapper) return;

    var errorId = field.id + '-error';
    var existingError = fieldWrapper.querySelector('.contact-form__field-error');

    if (existingError) {
      existingError.textContent = message;
      existingError.classList.add('contact-form__field-error--visible');
    } else {
      var errorElement = document.createElement('p');
      errorElement.className = 'contact-form__field-error contact-form__field-error--visible';
      errorElement.id = errorId;
      errorElement.textContent = message;
      fieldWrapper.appendChild(errorElement);
    }

    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', errorId);
  }

  function clearFieldError(field) {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;

    field.classList.remove('contact-form__input--error');
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');

    var fieldWrapper = field.closest('.contact-form__field');
    if (!fieldWrapper) return;

    var errorElement = fieldWrapper.querySelector('.contact-form__field-error');
    if (errorElement) errorElement.classList.remove('contact-form__field-error--visible');
  }

  function markFieldError(field) {
    showFieldError(field, getErrorMessage(field));
  }

  function showRadioGroupError(fieldset) {
    fieldset.classList.add('contact-form__fieldset--error');
    var errorId = fieldset.id ? fieldset.id + '-error' : 'radio-group-error';
    var existingError = fieldset.querySelector('.contact-form__field-error');

    if (existingError) {
      existingError.textContent = 'Please select an option';
      existingError.classList.add('contact-form__field-error--visible');
    } else {
      var errorElement = document.createElement('p');
      errorElement.className = 'contact-form__field-error contact-form__field-error--visible';
      errorElement.id = errorId;
      errorElement.textContent = 'Please select an option';
      fieldset.appendChild(errorElement);
    }
  }

  function clearRadioGroupError(fieldset) {
    fieldset.classList.remove('contact-form__fieldset--error');
    var errorElement = fieldset.querySelector('.contact-form__field-error');
    if (errorElement) errorElement.classList.remove('contact-form__field-error--visible');
  }

  function validateRadioGroup(form) {
    var fieldsets = form.querySelectorAll('.contact-form__fieldset');
    var allValid = true;

    fieldsets.forEach(function (fieldset) {
      var radios = fieldset.querySelectorAll('input[type="radio"][required]');
      if (radios.length === 0) return;

      var isChecked = Array.from(radios).some(function (r) { return r.checked; });

      if (isChecked) {
        clearRadioGroupError(fieldset);
      } else {
        showRadioGroupError(fieldset);
        allValid = false;
      }
    });

    return allValid;
  }

  function validateForm(form) {
    var fields = form.querySelectorAll('input[required], select[required], textarea[required]');
    var firstInvalid = null;

    fields.forEach(function (field) {
      // 跳过禁用或隐藏的字段
      if (field.disabled || field.closest('[hidden]')) return;

      prepareFieldForValidation(field);

      if (!field.checkValidity()) {
        markFieldError(field);
        if (!firstInvalid) firstInvalid = field;
      } else {
        clearFieldError(field);
      }
    });

    var radioValid = validateRadioGroup(form);

    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalid.focus();
      return false;
    }

    if (!radioValid) {
      var errorFieldset = form.querySelector('.contact-form__fieldset--error');
      if (errorFieldset) errorFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    return true;
  }

  function initializeForm(form) {
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.contactFormInitialized === 'true') return;

    form.dataset.contactFormInitialized = 'true';

    var isNewCustomerForm = form.dataset.contactFormMode === 'new';

    if (isNewCustomerForm) {
      if (form.querySelector('.contact-form__success')) {
        clearState(form);
      }
      restoreState(form);
      updateMaterialOtherField(form);
      updateBusinessTypeOtherField(form);
    }

    var handleFieldChange = function (event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement)) return;

      prepareFieldForValidation(target);

      if (isNewCustomerForm && target.hasAttribute('data-material-select')) {
        updateMaterialOtherField(form);
      }
      if (isNewCustomerForm && target.hasAttribute('data-business-type-select')) {
        updateBusinessTypeOtherField(form);
      }
      if (isNewCustomerForm && target.hasAttribute('data-contact-persist')) {
        writeState(form);
      }
      if (target.classList.contains('contact-form__input--error')) {
        if (target.checkValidity()) {
          clearFieldError(target);
        } else {
          markFieldError(target);
        }
      }
      if (target.type === 'radio') {
        var fieldset = target.closest('.contact-form__fieldset');
        if (fieldset) clearRadioGroupError(fieldset);
      }
    };

    var handleFieldBlur = function (event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement)) return;

      prepareFieldForValidation(target);

      if (!target.classList.contains('contact-form__input')) return;
      if (target.value !== '' && !target.checkValidity()) markFieldError(target);
    };

    var handleFieldInvalid = function (event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement)) return;

      prepareFieldForValidation(target);

      if (target.type === 'radio') {
        var radioFieldset = target.closest('.contact-form__fieldset');
        if (radioFieldset) showRadioGroupError(radioFieldset);
        return;
      }

      markFieldError(target);
    };

    form.addEventListener('input', handleFieldChange);
    form.addEventListener('change', handleFieldChange);
    form.addEventListener('focusout', handleFieldBlur);
    form.addEventListener('invalid', handleFieldInvalid, true);

    form.addEventListener('submit', async function (event) {
      if (form.dataset.contactNativeSubmit === 'true') return;

      event.preventDefault();

      if (form.dataset.contactSubmitting === 'true') {
        return;
      }

      if (!form.reportValidity()) {
        validateForm(form);
        setStatusMessage(form, '', '');
        return;
      }

      var isValid = validateForm(form);
      if (!isValid) {
        setStatusMessage(form, '', '');
        return;
      }

      if (!window.fetch || !window.FormData || !window.DOMParser) {
        fallbackToNativeSubmit(form);
        return;
      }

      if (isNewCustomerForm) {
        writeState(form);
      }

      setStatusMessage(form, DEFAULT_STATUS_MESSAGE, 'info');
      setSubmittingState(form, true);

      try {
        var result = await submitFormWithAjax(form);

        if (!result.response.ok) {
          if (shouldFallbackToNativeSubmission(result.response, result.html)) {
            setStatusMessage(form, 'A security check is required. Redirecting now...', 'info');
            fallbackToNativeSubmit(form);
            return;
          }

          setSubmittingState(form, false);
          setStatusMessage(form, getHttpErrorMessage(result.response, result.doc, result.html), 'error');
          return;
        }

        if (isChallengeResponse(result.response, result.html)) {
          setStatusMessage(form, 'One more security check is required. Redirecting now...', 'info');
          fallbackToNativeSubmit(form);
          return;
        }

        if (isSuccessResponse(result.response, result.doc, getSuccessPath(form))) {
          clearState(form);
          setStatusMessage(form, DEFAULT_SUCCESS_MESSAGE, 'success');
          redirectToSuccessPage(form);
          return;
        }

        setSubmittingState(form, false);
        setStatusMessage(form, getServerErrorMessage(result.doc) || DEFAULT_ERROR_MESSAGE, 'error');
      } catch (error) {
        setSubmittingState(form, false);
        setStatusMessage(form, getRequestErrorMessage(error), 'error');
      }
    });
  }

  function initialize(root) {
    getForms(root).forEach(initializeForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
